import React, { useState, Dispatch, SetStateAction } from "react";
import Typography from "@mui/material/Typography";
import SelectFilterDialog from "./SelectFilterDialog";
import InsightFiltersViewModel from "../../../ViewModels/InsightFiltersViewModel";
import FilterChipDisplay from "../../../../Filtering/FilterChipDisplay";

interface ISelectFilterContainerProps {
    filters: InsightFiltersViewModel
    setFilters: Dispatch<SetStateAction<InsightFiltersViewModel>>
    name: string
    label: string
    options: any[]
}

export default function SelectFilterContainer({ filters, setFilters, name, label, options }: ISelectFilterContainerProps) {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const text = <Typography variant='body1'>{`${label}: ${filters[name]}`}</Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setIsDialogOpen(true)} />
            <SelectFilterDialog
                open={isDialogOpen}
                setOpen={setIsDialogOpen}
                filters={filters}
                setFilters={setFilters}
                name={name}
                label={label}
                options={options} />
        </>
    );
};
